import React from 'react';

function DashboardIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      id="DashboardIcon"
      viewBox="0 0 18.5 24"
      className={className}
    >
      <g id="ic_dashboard_24px">
        <path
          id="Shape"
          d="M247.46,277.13h2a1.54,1.54,0,0,0,1.5-1.5v-8a1.54,1.54,0,0,0-1.5-1.5h-2a1.54,1.54,0,0,0-1.5,1.5v8A1.54,1.54,0,0,0,247.46,277.13Zm-.5-9.5a.47.47,0,0,1,.5-.5h2a.47.47,0,0,1,.5.5v8a.47.47,0,0,1-.5.5h-2a.47.47,0,0,1-.5-.5Z"
          transform="translate(-245.96 -256.13)"
        />
        <path
          id="Shape-2"
          d="M253.46,277.13h2a1.54,1.54,0,0,0,1.5-1.5v-18a1.54,1.54,0,0,0-1.5-1.5h-2a1.54,1.54,0,0,0-1.5,1.5v18A1.54,1.54,0,0,0,253.46,277.13Zm-.5-19.5a.47.47,0,0,1,.5-.5h2a.47.47,0,0,1,.5.5v18a.47.47,0,0,1-.5.5h-2a.47.47,0,0,1-.5-.5Z"
          transform="translate(-245.96 -256.13)"
        />
        <path
          id="Shape-3"
          d="M259.46,277.13h2a1.54,1.54,0,0,0,1.5-1.5v-14a1.54,1.54,0,0,0-1.5-1.5h-2a1.54,1.54,0,0,0-1.5,1.5v14A1.54,1.54,0,0,0,259.46,277.13Zm-.5-15.5a.47.47,0,0,1,.5-.5h2a.47.47,0,0,1,.5.5v14a.47.47,0,0,1-.5.5h-2a.47.47,0,0,1-.5-.5Z"
          transform="translate(-245.96 -256.13)"
        />
        <path
          id="Shape-4"
          d="M264,279.13h-17.5a.5.5,0,0,0,0,1H264a.5.5,0,0,0,0-1Z"
          transform="translate(-245.96 -256.13)"
        />
      </g>
    </svg>
  );
}

export default DashboardIcon;
